<template>
    <ValidationObserver v-slot="{ handleSubmit }" v-if="campaign">
        <form @submit.prevent="handleSubmit(onSubmit)">
            <div class="p-5">
                <div
                    class="d-flex justify-content-between align-items-center mb-4"
                >
                    <div class="c-title">
                        Questions - {{ campaign.title }}
                    </div>

                    <div class="ml-auto">
                        <RouterLink class="ml-3" :to="`/campaigns/view/${$route.params.id}`">
                            <button class="btn c-cancel-btn">Back</button>
                        </RouterLink>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-5 col-sm-12">
                        <div class="designation-items" v-if="questions.length">
                            <draggable handle=".sort-item" v-model="questions" @end="onSubmit">
                                <div v-for="(item) in questions" :key="item.question_id"
                                     class="cursor-pointer"
                                     @click.prevent="editItem(item)"
                                     :class="{'sort-item': DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_QUESTION_EDIT)}">
                                    <TextField
                                        v-model="item.question_text"

                                        name="sub_title"
                                            rules="required"
                                            readonly
                                            class-wrapper="designation-item"
                                    >
                                        <template #prepend-icon>
                                            <a style="cursor: move"
                                               @mousedown.left="isDragging = true"
                                               @mouseup.left="isDragging = false"
                                            >
                                                <img src="~@/assets/images/drag-icon.svg"
                                                     alt="">
                                            </a>
                                        </template>
                                        <template #append-icon v-if="DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_QUESTION_EDIT)">
                                            <a href="javascript:;" class=""
                                               @click="removeItem(item)">
                                                <img src="@/assets/images/trash.svg"/>
                                            </a>

                                        </template>
                                    </TextField>
                                </div>
                            </draggable>
                        </div>
                        <div v-else class="no-designation-item mb-5">
                            <p>
                                No questions were set for the campaign.
                            </p>
                            <p>
                                Click the + button to add a question.
                            </p>
                        </div>
                        <div v-if="DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_QUESTION_ADD)">
                            <a href="javascript:;" class="btn c-btn-add" @click="showAddDesignationModal">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>

                    <div class="col-5">

                    </div>
                </div>
            </div>
        </form>

        <modal-add-edit-campaign-question v-if="isShowAddQuestionModal"
                                          :data="data"
                                          @close="isShowAddQuestionModal = false"
                                          :campaign-id="campaign.campaign_id"
                                          @success="isShowAddQuestionModal = false; getCampaignQuestions()" />
    </ValidationObserver>
</template>

<script>
import TextField from '@/commons/FormElements/TextField.vue';
import DibbleJs from '@/dibble';
import DibbleApi from '@/api';
import draggable from 'vuedraggable';
import DibbleJS from "@/dibble";
import Authorizations from "@/utils/authorizations";
import ModalAddEditCampaignQuestion
    from "@/components/campaigns/components/ModalAddCampaignQuestion.vue";

export default {
    name: 'CampaignDesignations',
    computed: {
        Authorizations() {
            return Authorizations
        },
        DibbleJS() {
            return DibbleJS
        }
    },
    components: {
        ModalAddEditCampaignQuestion,
        TextField,
        draggable,
    },
    data() {
        return {
            isDragging: false,
            isRemovingItem: false,
            isShowAddQuestionModal: false,
            questions: [],
            campaign: null,
            data: null,
        };
    },
    methods: {
        showAddDesignationModal() {
            this.data = null;
            this.isShowAddQuestionModal = true;
        },
        onSubmit() {
            if (!DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_QUESTION_EDIT)) {
                return;
            }

            if (!this.questions.length) {
                DibbleJs.toastErrorMessage('Please add at least one question.');
                return;
            }

            const items = [];
            this.questions.forEach((item) => {
                items.push(item.question_id);
            });

            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.campaignSetQuestionsOrder,
                campaign_id: this.$route.params.id,
                question_ids: items.join(','),
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    DibbleJs.toastSuccessMessage('Questions order updated successfully.');
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        getCampaign() {
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.getCampaign,
                campaign_id: this.$route.params.id,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.campaign = response;
                    this.getCampaignQuestions()
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        getCampaignQuestions() {
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.campaignGetQuestions,
                campaign_id: this.$route.params.id,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.questions = response.questions;
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        editItem(item) {
            setTimeout(() => {
                if (!this.isRemovingItem) {
                    if (!DibbleJs.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_QUESTION_EDIT)) {
                        return;
                    }

                    this.data = item;
                    this.isShowAddQuestionModal = true;
                }
            }, 500);
        },
        removeItem(item) {
            this.isRemovingItem = true;
            setTimeout(() => {
                this.isRemovingItem = false;
            }, 1000);
            DibbleJs.confirmBox('Are you sure you want to delete this question?', () => {
                DibbleJs.showLoader();
                const data = {
                    '#request': DibbleApi.api.campaignRemoveQuestion,
                    campaign_id: this.$route.params.id,
                    question_id: item.question_id,
                };
                DibbleJs.callApiRequest(data, (response) => {
                    if (DibbleApi.isResponseSuccess(response)) {
                        DibbleJs.toastSuccessMessage('Question deleted successfully.');
                        this.getCampaignQuestions();
                    } else {
                        DibbleJs.toastErrorMessage(response.message);
                    }
                    DibbleJs.hideLoader();
                });
            });
        },
    },
    created() {
        this.getCampaign();
    },
};
</script>

<style lang="scss" scoped>
.c-title {
    color: #2178ab;
    font-size: 22px;
    font-weight: 700;
}

.c-cancel-btn {
    border-radius: 20px;
    background: #d9d9d9;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    width: 120px;
    color: #555e67;
    line-height: 140%;
}

.c-donations-btn, .c-distribution-btn {
    border-radius: 20px;
    background: #6CA779;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    width: 140px;
    color: #fff;
    line-height: 140%;
}

.c-distribution-btn {
    background: #7BBDEF;
    color: #555E67 !important;
    width: 160px;
}

.c-save-btn {
    border-radius: 20px;
    background: #2178ab;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    color: #fff;
    width: 120px;
    line-height: 140%;
}

.c-label {
    font-size: 20px;
    line-height: 24px;
    color: #555e67;
    margin-top: 33px;
    margin-bottom: 33px;
}

.c-upload {
    background-color: #e1e7e9;
    border-radius: 20px;
    padding: 24px 32px;
}

.c-tab-list {
    border-radius: 20px;
    overflow: hidden;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    margin-bottom: 28px;
}

.dropdown-btn {
    position: relative;

    span {
        display: block;

        &.top {
            font-size: 12px;
            line-height: 16px;
            color: #555E67;
        }
    }

    .dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        z-index: 1000;
        display: none;
        min-width: 10rem;
        text-align: left;
        list-style: none;

        background-clip: padding-box;
        border: none;
        border-radius: 30px;
        width: 275px;
        background: none;

        &.active {
            display: block;
        }

        .dropdown-item {
            color: #555E67;
            font-size: 20px;
            font-weight: 700;
            background-color: #EDF5F7;
            padding: 12px 35px;
            border-bottom: 1px solid #DEE6EA;

            &:first-child {
                border-top-left-radius: 20px;
                border-top-right-radius: 20px;
            }

            &:last-child {
                border-bottom-left-radius: 30px;
                border-bottom-right-radius: 30px;
                box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
            }

            &:hover {
                background-color: #bae3ef;
                color: #2178AB;
            }
        }
    }
}
.designation-item {
    input {
        color: #555E67 !important;
    }
}
.designation-append {
    .designation-default-label {
        border-radius: 20px;
        padding: 5px 10px;
        font-size: 12px;
        line-height: 16px;
        color: #7C7C7A;
        border: 1px solid #7C7C7A;
        font-weight: 500;
        margin-right: 10px;
    }
}
.c-btn-add {
    color: #fff;
    width: 61px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #2178ab;
    border-radius: 20px;
    font-size: 24px;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}
.no-designation-item {
    font-size: 18px !important;
    color: #000000 !important;
    line-height: 160% !important;
    font-weight: 600 !important;
}
.cursor-pointer {
    cursor: pointer;
}
</style>
